export default "__VITE_ASSET__wMJ91wCX__"